import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NovoClienteCadastroMultiselectComponent } from './novo-cliente-cadastro-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoClienteCadastroMultiselectComponent],
  exports: [NovoClienteCadastroMultiselectComponent]
})
export class NovoClienteCadastroMultiselectModule {}
